export default __webpack_public_path__ + "static/ProValue_1@1200-4f1f18e9bf03ed665458e56c46acfc4d.png";